module.exports = __webpack_public_path__ + "images/bioshock-infinite_rgba(0,0,0,0.7).283198f15004af544272faba8557e99f.jpg";